export const XTeamRole = {
  user: "user",
  // TECHNICIAN: "TECHNICIAN"
};
